import cookie from 'react-cookies';
import { REQUEST_GET_SAMA, SET_SAMA } from 'sama_global/modules/olimpic';
import { SUCCESS, FAILURE } from '@/modules/Requests';
import { types as guestTypes } from '@/modules/Guest';
import { setLocale, setLocaleMessages } from '@/modules/Locale';
import {
  SET_INIT,
  SET_TASKS,
  SET_TOKEN,
  SET_PROFILE,
  SET_AVTIVITY,
  SET_STUDENTS,
  REQUEST_STUDENTS,
  REQUEST_STUDENT_DELETE,
  REQUEST_STUDENT_CREATE,
  SET_GROUPS,
  REQUEST_GROUPS,
  REQUEST_GROUP_DELETE,
  SET_SCHEDULE,
  REQUEST_GET_SCHEDULE,
  REQUEST_ADD_SCHEDULE,
  REQUEST_DELETE_SCHEDULE,
  SET_SCHOOLS,
  REQUEST_SCHOOLS,
  REQUEST_SCHOOL_DELETE,
  SET_TEACHERS,
  REQUEST_TEACHER_PAID,
  REQUEST_TEACHERS,
  REQUEST_TEACHER_DELETE,
  REQUEST_LOAD_DATA,
  REQUEST_LOAD_TASKS,
  REQUEST_CONFIRM_CODE,
  REQUEST_CHANGE_THEME,
  GET_REPORTS,
  SET_REPORTS,
  fetchGroups,
  fetchSchedule,
  fetchSchools,
  fetchStudents,
  fetchTeachers,
  fetchLoadData,
  fetchLoadTransactions,
  SET_ROOMS,
  SET_THEME_DATA,
  REQUEST_ROOMS,
  SET_RATING,
  REQUEST_RATING,
  REQUEST_CONVERT_UCOINS,
  REQUEST_SAVE_PURCHASE,
  REQUEST_EDIT_DATA,
  REQUEST_INVITE_CONFIRM,
  REQUEST_INVITE_REJECT,
  SET_PRODUCTS,
  REQUEST_PRODUCTS,
  cleanUser,
  REQUEST_LOAD_TRANSACTIONS,
  SET_USER,
  fetchRequestRooms,
} from '@/modules/User';
import { actions as socketActions } from '@/modules/Socket';
import { types as certificationTypes } from '@/modules/Certification';
import { actions as examActions, types as examTypes } from '@/modules/Exams';
import {
  types as homeworkTypes,
  actions as homeworkActions,
} from '@/modules/Homework';
import {
  // actions as mainhomeActions,
  types as mainhomeworkTypes,
} from '@/modules/Mainhomeworks';
import {
  fetchActiveOlimpics,
  fetchOlimpic,
  fetchParticipation,
  REQUEST_GET_PARTICIPATION,
  SET_PARTICIPANT,
  REQUEST_GET_OLIMPIC,
  REQUEST_GET_OLIMPIC_ACTIVE,
  REQUEST_OLIMPIC_DELETE,
  REQUEST_OLIMPIC_CREATE,
  REQUEST_OLIMPIC_EDIT,
  SET_OLIMPIC,
  REQUEST_OLIMPIC_LIST,
  SET_OLIMPIC_LIST,
  REQUEST_PARTICIPATE,
  SET_ACTIVE,
} from '@/modules/Olimpic';
import { GET_FULLSCREEN_NEWS } from '@/modules/News';

export default store => next => action => {
  const token = cookie.load('Authorization');
  const { user } = store.getState();

  if (action.type === FAILURE) {
    if (action.meta.request === REQUEST_LOAD_DATA) {
      cookie.remove('Authorization', { path: '/' });
      store.dispatch(cleanUser());
      // store.dispatch(socketActions.disconnect());
    }
  }

  if (action.type === SUCCESS) {
    /* User */
    if (action.meta.request === guestTypes.REQUEST_LOGIN) {
      // Устанавливаем токен в Store после успешной авторизации
      store.dispatch({ type: SET_TOKEN, payload: token, meta: 'token' });
      // Загружаем данные пользователя после успешной авторизации
      // store.dispatch(socketActions.socketConnect());
      store.dispatch(fetchLoadData());
      store.dispatch(fetchRequestRooms());
      store.dispatch(fetchActiveOlimpics());
    }

    // При успешной инициализации данных пользователя
    if (action.meta.request === REQUEST_LOAD_DATA) {
      const response = action.payload.data;
      // Устанавливаем данные в Store : ...user
      store.dispatch({
        type: SET_PROFILE,
        payload: response,
        meta: 'profile',
      });
      // Устанавливаем флаг в Store : user.init
      store.dispatch({
        type: SET_INIT,
        payload: true,
        meta: 'init',
      });
      // Регистрируем ws
      // if (response._id) {
      //   store.dispatch(socketActions.userRegister(response._id));
      // }

      store.dispatch({
        type: SET_USER,
        payload: response,
        meta: 'user',
      });

      // Устанавливаем локаль если с сервера приходит значение отличное от клиента.
      // Store : user.lang и user.localeMessages
      if (user.lang !== response.lang) {
        store.dispatch(setLocale(response.lang));
        store.dispatch(setLocaleMessages(response.lang));

        cookie.save('language', response.lang);
      }

      if (store.getState().socket.status !== 'connected')
        store.dispatch(socketActions.socketConnect());
    }

    // Устанавливаем данные профиля пользователя в Store при успешной загрузке данных пользователя
    if (action.meta.request === REQUEST_LOAD_TASKS) {
      store.dispatch({
        type: SET_TASKS,
        payload: action.payload.data,
        meta: 'tasks',
      });
    }

    // Устанавливаем данные профиля пользователя в Store при успешной загрузке данных пользователя
    if (action.meta.request === REQUEST_CONFIRM_CODE) {
      store.dispatch({
        type: SET_AVTIVITY,
        payload: 2,
        meta: 'activity',
      });
    }
    if (action.meta.request === REQUEST_STUDENTS) {
      // TODO если возможность смотреть пароль нужно будет сделать для всех справочников, то присвоение password = originalPassword,
      // нужно будет вынести на бэк в модель User
      store.dispatch({
        type: SET_STUDENTS,
        payload: action.payload.data.map(student => ({
          ...student,
          password: student.new_password,
        })),
        meta: 'students',
      });
    }
    if (action.meta.request === REQUEST_STUDENT_DELETE) {
      store.dispatch(fetchStudents());
    }
    if (action.meta.request === REQUEST_GROUPS) {
      store.dispatch({
        type: SET_GROUPS,
        payload: action.payload.data,
        meta: 'groups',
      });
    }
    if (action.meta.request === REQUEST_GROUP_DELETE) {
      store.dispatch(fetchGroups());
    }
    if (action.meta.request === REQUEST_GET_SCHEDULE) {
      store.dispatch({
        type: SET_SCHEDULE,
        payload: action.payload.data,
        meta: 'schedule',
      });
    }
    if (action.meta.request === REQUEST_ADD_SCHEDULE) {
      store.dispatch(fetchSchedule());
    }
    if (action.meta.request === REQUEST_DELETE_SCHEDULE) {
      store.dispatch(fetchSchedule());
    }
    if (action.meta.request === REQUEST_CONVERT_UCOINS) {
      store.dispatch(fetchLoadData());
    }
    if (action.meta.request === REQUEST_LOAD_TRANSACTIONS) {
      store.dispatch(fetchLoadData());
    }
    if (action.meta.request === REQUEST_SAVE_PURCHASE) {
      store.dispatch(fetchLoadData());
      store.dispatch(fetchLoadTransactions());
    }
    if (action.meta.request === REQUEST_STUDENT_CREATE) {
      store.dispatch(fetchLoadData());
    }
    if (
      action.meta.request === REQUEST_INVITE_CONFIRM ||
      action.meta.request === REQUEST_INVITE_REJECT
    ) {
      store.dispatch(fetchLoadData());
    }
    if (action.meta.request === REQUEST_EDIT_DATA) {
      store.dispatch(fetchLoadData());
    }
    if (action.meta.request === REQUEST_SCHOOLS) {
      store.dispatch({
        type: SET_SCHOOLS,
        payload: action.payload.data,
        meta: 'schools',
      });
    }
    if (action.meta.request === REQUEST_SCHOOL_DELETE) {
      store.dispatch(fetchSchools());
    }
    if (action.meta.request === REQUEST_TEACHERS) {
      store.dispatch({
        type: SET_TEACHERS,
        payload: action.payload.data,
        meta: 'teachers',
      });
    }
    if (action.meta.request === REQUEST_TEACHER_PAID) {
      store.dispatch({
        type: SET_TEACHERS,
        payload: action.payload.data,
        meta: 'paid',
      });
    }

    if (action.meta.request === REQUEST_TEACHER_DELETE) {
      store.dispatch(fetchTeachers());
    }
    if (action.meta.request === homeworkTypes.REQUEST_HOMEWORK) {
      store.dispatch({
        type: homeworkTypes.SET_HOMEWORK,
        payload: action.payload.data,
        meta: 'homework',
      });
    }
    if (
      action.meta.request === mainhomeworkTypes.REQUEST_MAINHOMEWORKS_COMPLETED
    ) {
      store.dispatch({
        type: mainhomeworkTypes.SET_MAINHOMEWORKS,
        payload: action.payload.data,
        meta: 'countCompleted',
      });
    }
    if (
      action.meta.request === mainhomeworkTypes.REQUEST_TEACHER_MAINHOMEWORKS
    ) {
      store.dispatch({
        type: mainhomeworkTypes.SET_MAINHOMEWORKS,
        payload: action.payload.data,
        meta: 'studentswork',
      });
    }

    if (action.meta.request === mainhomeworkTypes.REQUEST_MAINHOMEWORKS) {
      store.dispatch({
        type: mainhomeworkTypes.SET_MAINHOMEWORKS,
        payload: action.payload.data,
        meta: 'works',
      });
    }
    // if (action.meta.request === mainhomeworkTypes.REQUEST_MAINHOMEWORKS_EDIT) {
    //   store.dispatch({
    //     type: mainhomeworkTypes.SET_MAINHOMEWORKS,
    //     payload: action.payload.data,
    //     meta: 'works',
    //   });
    // }
    if (action.meta.request === mainhomeworkTypes.REQUEST_MAINHOMEWORKS_ID) {
      store.dispatch({
        type: mainhomeworkTypes.SET_MAINHOMEWORKS,
        payload: action.payload.data,
        meta: 'mainworks',
      });
    }

    // if (action.meta.request === mainhomeworkTypes.REQUEST_MAINHOMEWORK_DELETE) {
    //   store.dispatch(mainhomeActions.fetchMainhomework());
    // }

    if (action.meta.request === REQUEST_ROOMS) {
      store.dispatch({
        type: SET_ROOMS,
        payload: action.payload.data,
        meta: 'rooms',
      });
    }
    if (action.meta.request === REQUEST_RATING) {
      store.dispatch({
        type: SET_RATING,
        payload: action.payload,
        meta: 'rating',
      });
    }
    if (action.meta.request === homeworkTypes.REQUEST_HOMEWORKS) {
      store.dispatch({
        type: homeworkTypes.SET_HOMEWORKS,
        payload: action.payload.data,
        meta: 'homeworks',
      });
      store.dispatch({
        type: homeworkTypes.SET_PAGE,
        payload: +action.payload.page,
        meta: 'page',
      });
      store.dispatch({
        type: homeworkTypes.SET_COUNT,
        payload: +action.payload.count,
        meta: 'count',
      });
      store.dispatch({
        type: homeworkTypes.SET_FILTER_DATA,
        payload: action.payload.filterData,
        meta: 'filterData',
      });
    }
    if (action.meta.request === GET_REPORTS) {
      store.dispatch({
        type: SET_REPORTS,
        payload: action.payload.data,
        meta: 'reports',
      });
    }
    if (action.meta.request === certificationTypes.REQUEST_LIST) {
      store.dispatch({
        type: certificationTypes.SET_LIST,
        payload: action.payload.data,
        meta: 'list',
      });
    }
    if (action.meta.request === examTypes.REQUEST_LIST) {
      store.dispatch({
        type: examTypes.SET_LIST,
        payload: action.payload.data,
        meta: 'list',
      });
    }
    if (action.meta.request === examTypes.REQUEST_ONE) {
      store.dispatch({
        type: examTypes.SET_ONE,
        payload: action.payload.data,
        meta: 'entity',
      });
    }

    if (action.meta.request === certificationTypes.REQUEST_USERS_LIST) {
      store.dispatch({
        type: certificationTypes.SET_USERS_LIST,
        payload: action.payload.data,
        meta: 'users',
      });
    }
    if (
      action.meta.request === examTypes.REQUEST_DELETE ||
      action.meta.request === examTypes.REQUEST_LOAD_CERTIFICATION
    ) {
      store.dispatch(examActions.fetchList());
    }

    if (action.meta.request === homeworkTypes.REQUEST_HOMEWORK_DELETE) {
      store.dispatch(homeworkActions.fetchHomeworks(0, 10));
    }

    if (action.meta.request === REQUEST_CHANGE_THEME) {
      store.dispatch({
        type: SET_THEME_DATA,
        payload: action.payload.data.theme,
        meta: 'theme',
      });
    }

    if (action.meta.request === REQUEST_PRODUCTS) {
      store.dispatch({
        type: SET_PRODUCTS,
        payload: action.payload.data,
        meta: 'products',
      });
    }
    // if (action.meta.request === arifmetikTypes.REQUEST_GET_ARGS) {
    //   store.dispatch({
    //     type: arifmetikTypes.SET_DATA,
    //     payload: action.payload.data,
    //     meta: 'data',
    //   });
    // }

    /* Olimpic */
    if (action.meta.request === REQUEST_GET_PARTICIPATION) {
      const response = action.payload.data;
      store.dispatch({
        type: SET_PARTICIPANT,
        payload: response,
        meta: 'participant',
      });
    }
    if (action.meta.request === REQUEST_PARTICIPATE) {
      store.dispatch(fetchParticipation());
      store.dispatch(fetchLoadData());
    }
    if (action.meta.request === REQUEST_GET_OLIMPIC) {
      const response = action.payload.data;

      store.dispatch({
        type: SET_OLIMPIC,
        payload: response,
        meta: 'olimpic',
      });
    }
    if (action.meta.request === REQUEST_GET_OLIMPIC_ACTIVE) {
      const response = action.payload.data;

      store.dispatch({
        type: SET_ACTIVE,
        payload: response,
      });
    }
    if (action.meta.request === GET_FULLSCREEN_NEWS) {
      store.dispatch({
        type: GET_FULLSCREEN_NEWS,
        payload: action.payload.data,
      });
    }
    if (
      action.meta.request === REQUEST_OLIMPIC_DELETE ||
      action.meta.request === REQUEST_OLIMPIC_CREATE ||
      action.meta.request === REQUEST_OLIMPIC_EDIT
    ) {
      store.dispatch(fetchOlimpic());
    }
    if (action.meta.request === REQUEST_OLIMPIC_LIST) {
      store.dispatch({
        type: SET_OLIMPIC_LIST,
        payload: action.payload.data,
        meta: 'list',
      });
    }
    if (action.meta.request === REQUEST_GET_SAMA) {
      store.dispatch({
        type: SET_SAMA,
        payload: action.payload.data,
        meta: 'sama',
      });
    }
  }
  return next(action);
};
